import BeeHiveMonitor from './BeeHiveMonitor';

function App() {
  return <BeeHiveMonitor />;
}

export default App;